import ArticleLayout from "@/components/feature/ArticleLayout";

export default function Article() {
  return <ArticleLayout slug="pandabuy-sheet-ultimate-guide" />;
}